import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../icons/Icons';

const DisplayTemplate = ({ children, onEditClick }) => (
    <div className="rec-display-wrap">
        <div className="rec-display-plain-text">{children}</div>
        <button
            className="rec-edit-button"
            name="edit"
            aria-label="Edit Content"
            title="Edit Content"
            onClick={onEditClick}>
            <span className="rec-sr-only">Click to Edit Content</span>
        </button>
        <div className="rec-edit-indicator"><Icons.IconEdit /></div>
    </div>
);

DisplayTemplate.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.any),
        PropTypes.string,
        PropTypes.object
    ]),
    onEditClick: PropTypes.func.isRequired
};

DisplayTemplate.defaultProps = {};

export default DisplayTemplate;
